import React from 'react';
import styles from './Footer.module.less';

export default function Footer(props) {
  return (
    <div className={styles.footer}>
      All content © {new Date().getFullYear()} Enzo Inc. All rights reserved.
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Footer.js